module.exports = __webpack_public_path__ + "img/CDT.f6e4a7af.svg";